<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Penilaian" >
            <br>
            <common-training-header :withUser="true" />
        </a-page-header>

        <a-card type="inner" size="small" style="margin-top: 24px">
            <a-skeleton :loading="loading" active>
                <a-table class="pcp-table" :columns='columns' :dataSource='items' rowKey="hash" :pagination="false">

                    <div slot="photo" slot-scope="record" style="text-align: center">
                        <a-avatar :src="record.photo" shape="square" :size="64" icon="user" />
                    </div>

                    <div slot="attendant" slot-scope="record" style="text-align: left">
                        <h4>
                           <a-icon type="user" /> {{ record.name }} <br />
                            <a :href="`tel:${record.mobile_phone}`"><a-icon type="phone" /></a> {{ record.mobile_phone }}
                        </h4>
                    </div>

                    <div slot="branch" slot-scope="record" class="text-left">
                        <h4>
                            <a-icon type="bank" /> {{ record.members[0].position.branch.name }} <br />
                            <a-icon type="team" /> {{ record.members[0].position.name }}
                        </h4>
                    </div>

                    <div slot="education" slot-scope="record" style="text-align: left">
                        {{ record.education }}
                    </div>

                    <div style="text-align: center" slot-scope="record" slot="action">
                        <a-tooltip title="Business Result">
                            <a-button icon="carry-out" :href="routeUri('admin.performance.scoring.business-result', { user: record.hash})" size="small"/>
                        </a-tooltip>

                        <a-tooltip title="Business Process">
                            <a-button icon="sync" :href="routeUri('admin.performance.scoring.business-process', { user: record.hash})" size="small"/>
                        </a-tooltip>

                        <a-tooltip title="Soft Competency">
                            <a-button icon="book" :href="routeUri('admin.performance.scoring.soft-competency', { user: record.hash})" size="small" />
                        </a-tooltip>

                    </div>
                </a-table>
            </a-skeleton>
        </a-card>
    </div>
</template>

<script>
const columns = [
    {
        key: 'photo',
        title: 'Foto',
        align: 'center',
        width: 65,
        scopedSlots: {customRender: 'photo'},
    }, {
        key: 'attendant',
        title: 'Peserta',
        align: 'left',
        scopedSlots: {customRender: 'attendant'},
    }, {
        key: 'branch',
        title: 'Cabang',
        align: 'left',
        scopedSlots: {customRender: 'branch'},
    }, {
        key: 'education',
        title: 'Pendidikan',
        align: 'center',
        scopedSlots: {customRender: 'education'},
    }, {
        key: 'action',
        title: 'Action',
        align: 'center',
        width: 150,
        scopedSlots: {customRender: 'action'}
    }
]

export default {
    data() {
        return {
            columns,
            loading: false,
            items: [],
            filters: {
                q: null,
                page: 1,
            },
        }
    },
    created() {
        this.data = this.getDefaultPagination()
        this.filters = _.merge(this.filters, this.$laravel.request)
        this.getItems()
    },
    methods: {
        getItems() {
            this.loading = true

            this.$http
                .get(this.routeUri('api.performance.index'), {params: this.filters})
                .then(response => {
                    this.items = response.data.attendants
                })
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false));
        },
        tableChanged(pagination) {
            this.filters.page = pagination.current
            this.pushState(this.filters)
            this.getItems()
        },
    }
}
</script>
